import React from "react";
import { useParams } from "react-router-dom";

import PageWrapper from "../../../../components/layout/page/PageWrapper";

import CreatorsView from "../views/CreatorsView";
import CreatorView from "../views/CreatorView";

export default function CreatorsPage({ userId }) {
  const { username } = useParams();

  return (
    <PageWrapper>
      {username ? (
        <CreatorView userId={userId} />
      ) : (
        <CreatorsView userId={userId} />
      )}
    </PageWrapper>
  );
}
